






























import Vue from 'vue';
import { SchemaModel } from '@/types';
import DynamicForm from '@/components/shared/DynamicForm.vue';
import { mapActions, mapGetters } from 'vuex';
import { confirmationHelper } from '@/mixins/confirmationHelper';
import DefaultBuiltInListItem from '@/components/configuration/listMaintenance/DefaultBuiltInListItem.vue';
import ExampleCustomBuiltInListItem from '@/components/configuration/listMaintenance/ExampleCustomBuiltInListItem.vue';
import { Components } from '@/customer';
export default Vue.extend({
  name: 'BuiltInListItem',
  mixins: [confirmationHelper],
  props: {
    schemas: {
      type: Array as () => SchemaModel[],
      required: true
    },
    componentName: {
      type: String,
      required: true
    },
    showModal: {
      type: Boolean,
      required: true
    },
    modalTitle: {
      type: String,
      required: true
    },
    isLoading: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    ...mapActions('applicationDirtyStore', ['setApplicationDirty']),
    async onCancelClickedAsync(this: any, invalid: boolean, dirty: boolean) {
      if (dirty) {
        const hasUnsavedChangesToKeep: boolean = await this.hasUnsavedChangesToKeepAsync(this.$bvModal, true);
        if (hasUnsavedChangesToKeep) {
          return;
        }
      }
      this.setApplicationDirty(false);
      this.$emit('update:listitem-cancelled');
    },
    async onSubmitAsync(this: any) {
      this.setApplicationDirty(false);
      this.$emit('update:listitem-saved');
    },
    async updateSchema(this: any, schema: SchemaModel[]) {
      this.$emit('update:listitem-changed', schema);
    },
    onDirtyForm(this: any, dirty: boolean) {
      if (this.isApplicationDirty) {
        return;
      }
      if (dirty) {
        this.setApplicationDirty(dirty);
      }
    }
  },
  components: { DynamicForm, DefaultBuiltInListItem, ExampleCustomBuiltInListItem, ...Components.BuiltInListItem },
  computed: {
    ...mapGetters('applicationDirtyStore', ['isApplicationDirty'])
  }
});
